import React from 'react';

import styles from './styles.css';

const Spinner = () => (
  <div className="spinner-container" id="test-spinner">
    <div className="lds-default">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
    <style jsx>{styles}</style>
  </div>
);

export default Spinner;
